import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { withStyles } from '@material-ui/styles';

import { getDate, getMonthDate } from 'lib/commonLib';

import LabelFilterWrap from 'components/molecules/LabelFilterWrap';

import SingleDatePickerWrapper from './PresetSingleDate';

import 'react-dates/lib/css/_datepicker.css';

const styles = (theme) => ({
  pickerRoot: {
    cursor: 'auto',
    padding: '0 5px',
    '.en &': { minWidth: '240px' },
  },
  noLabelPicker: {
    '& .DateInput_input': {
      height: 34,
      padding: 6,
      border: '1px solid #e5e8eb',
      borderRadius: 4,
      fontSize: 13,
    },
  },
});

class SingleDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }

  render() {
    const {
      classes,
      id,
      handleOnChange = (f) => f,
      locale,
      label,
      filtered,
      initialDate,
      useMonthDate,
      ...rest
    } = this.props;
    const { focusedInput } = this.state;

    const DateRangePic = (
      <SingleDatePickerWrapper
        isOutsideRange={() => false}
        displayFormat={
          locale === 'ko'
            ? !useMonthDate
              ? 'MMM DD일'
              : 'YY년 MMM'
            : moment.localeData().longDateFormat('L')
        }
        id={id}
        onDateChange={(newDate) => {
          if (newDate !== null) {
            if (!useMonthDate) {
              handleOnChange({
                [id]: getDate(newDate),
              });
            } else {
              handleOnChange({
                [id]: getMonthDate(newDate),
              });
            }
          }
        }}
        {...rest}
        numberOfMonths={1}
        focused={focusedInput}
        initialDate={initialDate}
        placeholder="날짜 선택"
        monthFormat="MMMM YYYY"
      />
    );

    return (
      <div className={clsx(classes.singleDateRoot, 'mb-DateRangePicker')}>
        {!!label ? (
          <LabelFilterWrap
            className={classes.pickerRoot}
            label={label}
            filtered
          >
            {DateRangePic}
          </LabelFilterWrap>
        ) : (
          <div className={classes.noLabelPicker}>{DateRangePic}</div>
        )}
      </div>
    );
  }
}

export default connect(
  ({ locale }) => ({
    locale: locale.locale,
  }),
  null
)(withStyles(styles)(SingleDate));
